import PublicHero from "./PublicHero";
import PublicMembers from "./PublicMembers";
import PublicFeaturedServices from "./PublicFeaturedServices";
import PublicStats from "./PublicStats";
import PublicAbout from "./PublicAbout";
import PublicTestimonials from "./PublicTestimonials";
import PublicAppointment from "./PublicAppointment";
import PublicGetInTouch from "./PublicGetInTouch";
import PublicBranches from "./PublicBranches";

const PublicHome = () => (
  <>
    <PublicHero />
    <PublicMembers />
    <PublicFeaturedServices />
    <PublicStats />
    <PublicAbout />
    <PublicTestimonials />
    <PublicAppointment />
    <PublicGetInTouch />
    <PublicBranches />
  </>
);

export default PublicHome;